import type { oz } from '@weft/utils';
import type { ZodObject, ZodRawShape } from 'zod';
import { CreatedEntitySchema } from './created-entity';

export function created<Shape extends ZodRawShape>(entity: ZodObject<Shape>) {
  return entity.merge(CreatedEntitySchema);
}

export type CreatedShape<Shape extends ZodRawShape> = ReturnType<typeof created<Shape>>;

export type Created<Shape> = Shape extends ZodRawShape
  ? oz.infer<CreatedShape<Shape>> 
  : never;
